import { useEffect, useRef, useState } from "react";
import Flip from "../Flip/Flip";

let isFirst = true;
const DURATION = 3000;
export const Counter = ({ total }) => {
  const difference = useRef(0);
  const [count, setCount] = useState(total);

  useEffect(() => {
    difference.current = total - count;
  }, [total, count]);

  useEffect(() => {
    let interval;
    if (isFirst || difference.current < 0) {
      setCount(total);
      isFirst = false;
    } else {
      interval = setInterval(
        () => {
          setCount((state) => {
            if (state === total) {
              clearInterval(interval);
              return state;
            }
            return state + 1;
          });
        },
        difference.current >= 5 ? DURATION / difference.current : 1000
      );
    }
    return () => clearInterval(interval);
  }, [total]);

  return <Flip value={count} />;
};
